import { useEffect,useState } from 'react'

type SaveState='saved'|'saving'|'error'
// Several editors can be mounted at once (e.g. journal guidance + reflection), so state is
// tracked per source: one editor's later "saved" must never hide another editor's error.
export default function SaveStateIndicator(){
 const[states,setStates]=useState<Record<string,SaveState>>({})
 useEffect(()=>{
  const onState=(event:Event)=>{
   const detail=(event as CustomEvent<{state?:SaveState|'detached';source?:string}>).detail
   const source=detail?.source||'default',next=detail?.state
   if(!next)return
   setStates(current=>{
    const copy={...current}
    if(next==='detached')delete copy[source];else copy[source]=next
    return copy
   })
  }
  window.addEventListener('dawwin:save-state',onState)
  return()=>window.removeEventListener('dawwin:save-state',onState)
 },[])
 const values=Object.values(states)
 const state:SaveState=values.includes('error')?'error':values.includes('saving')?'saving':'saved'
 const label=state==='saving'?'Saving…':state==='error'?'Not saved':'Autosaved'
 return <span className={`save-state save-state-${state}`} aria-live="polite" title={state==='error'?'Qirtaas did not confirm your latest changes. They are still in the editor; nothing has been discarded.':undefined}>
  <i/> {label}
  {state==='error'&&<button type="button" className="save-state-retry" onClick={()=>window.dispatchEvent(new Event('dawwin:save-retry'))}>Retry</button>}
 </span>
}
